// src/pos/orderSeq.ts
import { refreshRuntimeConfig } from '../services/config';
import { getDeviceSettings, pushToServer, setDeviceSettingsBulk } from '../services/deviceSettings';
import { message } from 'antd';

const KEY = 'local_order_seq';
const DEVICE_PREFIX = 'device_prefix';

/**
 * Lokalni kružni brojač 0001..9999.
 * Siguran za offline; čuvamo u device_settings.
 */
export async function nextOrderCode(): Promise<string> {
  const s = await getDeviceSettings([KEY, DEVICE_PREFIX]);
  let val = Number(s?.[KEY] ?? 0) || 0;

  val = (val + 1) % 10000;
  if (val === 0) val = 1;
  const toSave = {
      local_order_seq: Number(val)
    };
    try {
      await setDeviceSettingsBulk(toSave);
      try {
        await pushToServer(
          Object.entries(toSave).map(([key, value]) => ({ key, value }))
        );
      } catch {}
      await refreshRuntimeConfig();
     } catch (e: any) {
      message.error(e.message || String(e));
    } finally {
     }
     
     //return PREFIX + 3 digits
     const prefix = String(s?.[DEVICE_PREFIX] || 'A').toUpperCase().substring(0,1);
     return prefix + val.toString().padStart(4, '0');
}
